import { useEffect, useRef } from 'react'
import { AlertWebSocket } from '../api/ws'
import { useAlertStore } from '../store/alertStore'
import { useAuthStore } from '../store/authStore'
import type { WsSubscribeFilter } from '../types/cap'

export function useLiveAlerts(filter: WsSubscribeFilter = {}) {
  const token = useAuthStore((s) => s.token)
  const clearAuth = useAuthStore((s) => s.clearAuth)
  const { upsertAlert, cancelAlert, setLiveConnected } = useAlertStore()
  const wsRef = useRef<AlertWebSocket | null>(null)

  useEffect(() => {
    const ws = new AlertWebSocket(filter)
    wsRef.current = ws

    ws.onConnected = () => setLiveConnected(true)
    ws.onDisconnected = () => setLiveConnected(false)
    ws.onAuthError = () => clearAuth()

    const remove = ws.addHandler((msg) => {
      if (msg.type === 'alert.new' || msg.type === 'alert.update') {
        upsertAlert(msg.data)
      } else if (msg.type === 'alert.cancel') {
        cancelAlert(msg.data.id)
      }
    })

    ws.connect(token ?? undefined)

    return () => {
      remove()
      ws.disconnect()
      setLiveConnected(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  // Update filter without reconnecting
  useEffect(() => {
    wsRef.current?.updateFilter(filter)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filter)])
}
